import * as z from "zod";

/**
 * Frees the name and the team's unverified allowance. Records orphan rather
 * than being deleted, so a merchant who mistyped a domain is not stuck.
 */
export const releaseDnsDomain = {
  name: "releaseDnsDomain" as const,
  input: z.object({ domain: z.string() }),
  output: z.null(),
};
